import { useEffect, useState } from 'react'

const Corpobackup = ({ data, atual1, atual2, atual3, atual, index }) => {
  const [check, setCheck] = useState(data.check_bkp)
  const [checkSt, setCheckSt] = useState('Não conferido')
  const [status, setStatus] = useState('success')
  const [field, setField] = useState('')
  const [field_1, setField_1] = useState('')
  const [field_2, setField_2] = useState('')
  const [field_3, setField_3] = useState('')
  const [field_4, setField_4] = useState('')
  useEffect(() => {
    if (data.success != 0) setStatus('danger')
  })

  useEffect(() => {
    if (data.files) {
      return setField(data.files)
    } else if (data.size) {
      return setField(data.size)
    } else if (data.disc_space) {
      return setField(data.disc_space)
    } else if (data.success) {
      return setField(data.success)
    } else {
      setField('Sem dados para')
    }
  })
  useEffect(() => {
    if (atual1.files) {
      return setField_1(atual1.files)
    } else if (atual1.size) {
      return setField_1(atual1.size)
    } else if (atual1.disc_space) {
      return setField_1(atual1.disc_space)
    } else if (atual1.success) {
      return setField_1(atual1.success)
    } else {
      setField_1('Sem dados para')
    }
  })
  useEffect(() => {
    if (atual2.files) {
      return setField_2(atual2.files)
    } else if (atual2.size) {
      return setField_2(atual2.size)
    } else if (atual2.disc_space) {
      return setField_2(atual2.disc_space)
    } else if (atual2.success) {
      return setField_2(atual2.success)
    } else {
      setField_2('Sem dados para')
    }
  })
  useEffect(() => {
    if (atual3.files) {
      return setField_3(atual3.files)
    } else if (atual3.size) {
      return setField_3(atual3.size)
    } else if (atual3.disc_space) {
      return setField_3(atual3.disc_space)
    } else if (atual3.success) {
      return setField_3(atual3.success)
    } else {
      setField_3('Sem dados para')
    }
  })
  const getData = new Date(data.started_at).toLocaleDateString()
  const handleData = getData.slice('/')
  const dia = handleData[3]
  return (
    <tbody>
      <tr>
        <td>{data.name_empresa}</td>
        <td>{data.host}</td>
        <td>{data.backup}</td>

        <td>{new Date(atual3[index].started_at).toLocaleDateString()}</td>

        <td>{atual3[index].files}</td>
        <td>{atual3[index].size}</td>
        <td>{atual3[index].disc_space}</td>

        <td>{new Date(atual2[index].started_at).toLocaleDateString()}</td>

        <td>{atual2[index].files}</td>
        <td>{atual2[index].size}</td>
        <td>{atual2[index].disc_space}</td>

        <td>{new Date(atual1[index].started_at).toLocaleDateString()}</td>

        <td>{atual1[index].files}</td>
        <td>{atual1[index].size}</td>
        <td>{atual1[index].disc_space}</td>

        <td>{new Date(data.started_at).toLocaleDateString()}</td>
        <td>{data.files}</td>
        <td>{data.size}</td>
        <td>{data.disc_space}</td>
      </tr>
    </tbody>
  )
}

export default Corpobackup
